const DELIVERY_CONFIRMATION_TITLE = 'Confirmação de recebimento';

const DELIVERY_CONFIRMATION_MESSAGE =
  'vamos verificar o que aconteceu com seu pacote, mas antes precisamos de algumas informações:';

const DELIVERY_CONFIRMATION_RECEIVED = 'Seu pacote foi recebido por ';

const DELIVERY_CONFIRMATION_RECEIVED_TEXT =
  ' Você já conferiu com quem recebeu?';

const DELIVERY_CONFIRMATION_TEXT =
  'Se você mora em condomínio, já viu se o seu pacote está na portaria?';

const DENY_DELIVERY_BUTTON_TEXT = 'Vi e não está';

const CONFIRM_DELIVERY_BUTTON_TEXT = 'Vi e já está comigo';

export {
  DELIVERY_CONFIRMATION_TITLE,
  DELIVERY_CONFIRMATION_MESSAGE,
  DELIVERY_CONFIRMATION_RECEIVED,
  DELIVERY_CONFIRMATION_RECEIVED_TEXT,
  DELIVERY_CONFIRMATION_TEXT,
  DENY_DELIVERY_BUTTON_TEXT,
  CONFIRM_DELIVERY_BUTTON_TEXT
};
